export default __webpack_public_path__ + "static/media/SurveyMeta.ab3f0d62.svg";